export default function(n) {
  return n == 1 ? 'one' : 'other';
}
